module.exports = __webpack_public_path__ + "static/iso-2024-b16e1f21bb46eb6454f5cf5cd717e55a.jpg";